import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconBook({
  fill = 'var(--sapphire-20)',
  width = 24,
  height = 24,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 16V20H8C6.89543 20 6 19.1046 6 18V18M18 16H8C6.89543 16 6 16.8954 6 18V18M18 16V4L8 4C6.89543 4 6 4.89543 6 6L6 18M9 8H15" stroke={fill} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
